import { render } from "./CashierTotalOrderComponent.vue?vue&type=template&id=8d686b44&scoped=true"
import script from "./CashierTotalOrderComponent.vue?vue&type=script&lang=js"
export * from "./CashierTotalOrderComponent.vue?vue&type=script&lang=js"

import "./CashierTotalOrderComponent.vue?vue&type=style&index=0&id=8d686b44&lang=scss&scoped=true"

import exportComponent from "/var/www/cose-cashier/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d686b44"]])

export default __exports__